const guestRu: Record<string, string> = {
  "guest.header.venueFallback": "Заведение",
  "guest.header.help": "Помощь",
  "guest.language.label": "Язык",
  "guest.legal.terms": "Условия",
  "guest.legal.privacy": "Политика конфиденциальности",
  "guest.help.title": "Помощь",
  "guest.help.body": "Мы уведомили официанта. Если помощь всё ещё нужна, закройте это сообщение и сообщите ему об этом.",
  "guest.loading": "Загрузка…",
  "guest.payment.success.title": "Оплата успешна",
  "guest.payment.success.remaining": "Осталось оплатить: {amount} {currency}",
  "guest.payment.success.allPaid": "Все оплачено. Спасибо!",
  "guest.payment.cta.done": "Пропустить",
  "guest.payment.cta.another": "Добавить оплату",
  "guest.payment.cta.share": "Поделиться",
  "guest.payment.cta.emptyCartAndPay": "Оплатить",
  "guest.payment.cta.preparing": "Подготовка…",
  "guest.payment.cta.continue": "Далее",
  "guest.payment.cta.chooseAmount": "Выбрать сумму",
  "guest.payment.cta.continueToTip": "К чаевым",
  "guest.payment.cta.continueToPay": "К оплате",
  "guest.feedback.header": "Как вы нас нашли?",
  "guest.feedback.body.lovedIt": "Понравилось? Оцените нас в один тап.",
  "guest.feedback.body.improve": "Не идеально? Напишите нам приватно.",
  "guest.feedback.cta.publicReview": "Очень понравилось ⭐⭐⭐⭐⭐",
  "guest.feedback.cta.privateFeedback": "Написать нам",
  "guest.feedback.socialProof": "{count}+ гостей оценили нас на 5★",
  "guest.feedback.source.question": "Как вы нас нашли?",
  "guest.feedback.source.google": "Google",
  "guest.feedback.source.instagram": "Instagram",
  "guest.feedback.source.tiktok": "TikTok",
  "guest.feedback.source.tripadvisor": "TripAdvisor",
  "guest.feedback.source.friends": "Друзья",
  "guest.feedback.source.returning": "Уже был(а)",
  "guest.feedback.source.press": "Пресса",
  "guest.feedback.source.walkedBy": "Проходил(а) мимо",
  "guest.feedback.destination.choose": "Где хотите оставить отзыв?",
  "guest.feedback.secondary.title": "Другие площадки для отзыва",
  "guest.feedback.private.helper": "Откроет почтовое приложение с готовым шаблоном.",
  "guest.feedback.destination.email": "Почта",
  "guest.feedback.destination.review": "Отзыв",
  "guest.feedback.visitType.label": "Вы у нас впервые?",
  "guest.feedback.visitType.firstTime": "В первый раз",
  "guest.feedback.visitType.returning": "Уже бывал(а)",
  "guest.tabs.payment": "Оплата",
  "guest.tabs.newPurchases": "Новые",
  "guest.selection.title": "Что оплатить",
  "guest.selection.subtitle": "Выберите счета",
  "guest.selection.selectAll": "Все",
  "guest.selection.clear": "Сброс",
  "guest.selection.emptyOrders": "Здесь будут ваши счета",
  "guest.selection.notPayable": "Нет доступных к оплате счетов",
  "guest.intent.title": "Выберите действие",
  "guest.intent.addPositions": "Добавить позиции",
  "guest.intent.payAllPositions": "Оплатить весь стол",
  "guest.intent.payMyPositions": "Оплатить мои позиции",
  "guest.intent.selectMyItemsTitle": "Выберите мои позиции",
  "guest.intent.selectAllInOrder": "Выбрать все: {orderLabel}",
  "guest.intent.clearSelection": "Очистить",
  "guest.intent.paySelectedItems": "Оплатить выбранные позиции",
  "guest.intent.selectMyItemsEmpty": "Пока нет доступных позиций для выбора.",
  "guest.intent.itemsUnavailableReason": "Состав открытого заказа временно недоступен. Попросите официанта обновить стол перед оплатой отдельных позиций.",
  "guest.intent.callWaiter": "Позвать официанта",
  "guest.intent.leaveTip": "Оставить чаевые",
  "guest.order.whose": "Чей заказ?",
  "guest.order.guestName": "Гость: {name}",
  "guest.order.newOrder": "Новый заказ",
  "guest.order.nameModal.title": "Чей заказ?",
  "guest.order.nameModal.placeholder": "Необязательно",
  "guest.loyalty.add": "Лояльность",
  "guest.loyalty.modalTitle": "Карта лояльности",
  "guest.loyalty.visitOptional": "Карта лояльности (необязательно)",
  "guest.loyalty.enterManually": "Введите номер карты вручную",
  "guest.loyalty.lookupLabel": "Телефон или карта лояльности",
  "guest.loyalty.lookupMode.auto": "Определить автоматически",
  "guest.loyalty.lookupMode.phone": "Телефон",
  "guest.loyalty.lookupMode.card": "Карта лояльности",
  "guest.loyalty.lookupPlaceholder": "Телефон (+...) или номер карты",
  "guest.loyalty.phonePlaceholder": "+37128712007",
  "guest.loyalty.placeholder": "8-24 цифры",
  "guest.loyalty.formatHint": "Допустимы только 8-24 цифры.",
  "guest.loyalty.phoneFormatHint": "Используйте международный формат, например +37128712007.",
  "guest.loyalty.lookupHint": "Введите телефон или номер карты лояльности.",
  "guest.loyalty.lookupRequired": "Введите телефон или номер карты лояльности.",
  "guest.loyalty.badgeMasked": "Лояльность {mask}",
  "guest.loyalty.current": "Текущая карта: {mask}",
  "guest.loyalty.notSet": "Не привязана",
  "guest.loyalty.change": "Изменить",
  "guest.loyalty.collapsible.prompt": "Есть карта лояльности?",
  "guest.loyalty.collapsible.selected": "Лояльность: {mask}",
  "guest.loyalty.remove": "Удалить",
  "guest.loyalty.sourceGuest": "Указал гость",
  "guest.loyalty.sourceStaff": "Указал официант",
  "guest.loyalty.invalidFormat": "Номер карты должен содержать 8-24 цифры.",
  "guest.loyalty.saveFailed": "Не удалось сохранить карту лояльности.",
  "guest.loyalty.removeFailed": "Не удалось удалить карту лояльности.",
  "guest.loyalty.error.tableNotLinked":
    "Этот стол пока не связан с POS. Попросите сотрудника привязать стол и попробуйте снова.",
  "guest.loyalty.error.placeNotFound": "Эта гостевая ссылка больше неактивна. Попросите новый QR-код.",
  "guest.loyalty.error.customerNotFound": "Не обнаружено, обратитесь к персоналу заведения.",
  "guest.loyalty.applied": "Карта лояльности привязана.",
  "guest.loyalty.removed": "Карта лояльности удалена.",
  "guest.loyalty.saving": "Сохранение…",
  "guest.loyalty.scan": "Сканировать камерой",
  "guest.loyalty.scanStarting": "Запуск камеры…",
  "guest.loyalty.scanUnsupported": "Сканер камерой не поддерживается в этом браузере.",
  "guest.loyalty.scanPermissionDenied": "Камера недоступна. Проверьте разрешения браузера.",
  "guest.loyalty.scanNoCard": "Не удалось распознать номер карты лояльности.",
  "guest.loyalty.scanAmbiguous": "Обнаружено несколько номеров карты.",
  "guest.loyalty.scanSelectCandidate": "Выберите правильный номер ниже.",
  "guest.common.cancel": "Отмена",
  "guest.common.clear": "Очистить",
  "guest.common.save": "Сохранить",
  "guest.common.close": "Закрыть",
  "guest.common.options": "Опции",
  "guest.cart.inclOptions": "(вкл. опции)",
  "guest.status.partiallyPaid": "Частично оплачен",
  "guest.status.open": "Открыт",
  "guest.status.closed": "Закрыт",
  "guest.theme.label": "Тема",
  "guest.theme.system": "Система",
  "guest.theme.light": "Светлая",
  "guest.theme.dark": "Темная",
  "guest.preorders.title": "Предзаказы",
  "guest.preorders.subtitle.table": "Стол {tableLabel}",
  "guest.preorders.subtitle.fallback": "Заказы, отправленные официанту",
  "guest.preorders.refresh": "Обновить",
  "guest.preorders.error.title": "Не удалось загрузить предзаказы.",
  "guest.preorders.error.linkInactive": "Ссылка больше не активна.",
  "guest.preorders.error.loadFailed": "Ошибка загрузки предзаказов",
  "guest.preorders.loading": "Загрузка…",
  "guest.preorders.empty": "",
  "guest.preorders.status.pending": "В работе",
  "guest.preorders.status.approved": "Принят",
  "guest.preorders.status.resolved": "Отправлен в POS",
  "guest.preorders.status.rejected": "Отклонен",
  "guest.preorders.status.canceled": "Закрыт",
  "guest.preorders.sentAt": "Отправлен {time}",
  "guest.preorders.updatedAt": "Обновлен {time}",
  "guest.preorders.itemFallback": "Позиция",
  "guest.preorders.course": "Порядок подачи {course}",
  "guest.preorders.noItems": "Нет позиций",
  "guest.scheduledVisit.success.title": "Предзаказ оплачен",
  "guest.scheduledVisit.success.body": "Оплата завершена. Предзаказ сейчас в обработке.",
  "guest.scheduledVisit.success.addItems": "Добавить еще блюда",
  "guest.scheduledVisit.success.back": "Назад к столу",
  "guest.scheduledVisit.success.reservationNumber": "Бронь №",
  "guest.scheduledVisit.success.date": "Дата",
  "guest.scheduledVisit.success.time": "Время",
  "guest.scheduledVisit.success.place": "Стол",
  "guest.scheduledVisit.success.waitlist": "Лист ожидания (стол пока не назначен)",
  "guest.scheduledVisit.success.guestName": "Имя гостя",
  "guest.scheduledVisit.success.preorderItems": "Состав предзаказа",
  "guest.scheduledVisit.success.course": "Порядок подачи {course}",
  "guest.scheduledVisit.success.subtotal": "Сумма",
  "guest.scheduledVisit.success.paid": "Оплачено",
  "guest.scheduledVisit.success.remaining": "Остаток",
  "guest.scheduledUnified.common.loading": "Загрузка визита…",
  "guest.scheduledUnified.common.backToPlace": "Назад к столу",
  "guest.scheduledUnified.common.back": "Назад",
  "guest.scheduledUnified.common.continue": "Далее",
  "guest.scheduledUnified.visit.title": "Запланированный визит",
  "guest.scheduledUnified.visit.subtitle": "Выберите дату, время и вариант стола",
  "guest.scheduledUnified.visit.merchantFallback": "Заведение",
  "guest.scheduledUnified.visit.dateLabel": "Дата",
  "guest.scheduledUnified.visit.guestsLabel": "Гости",
  "guest.scheduledUnified.visit.durationLabel": "Длительность (мин)",
  "guest.scheduledUnified.visit.availableTimeLabel": "Доступное время",
  "guest.scheduledUnified.visit.noSlots": "На выбранную дату нет слотов.",
  "guest.scheduledUnified.visit.noTableAssigned": "Стол пока не назначен. Официант назначит стол перед доступом к предзаказу.",
  "guest.scheduledUnified.cart.title": "Корзина",
  "guest.scheduledUnified.cart.stepHint": "Шаг корзины готов. Позиции можно добавить сразу после подтверждения брони.",
  "guest.scheduledUnified.cart.existingCount": "Локальных корзин: {count}",
  "guest.scheduledUnified.cart.empty": "Пока нет позиций.",
  "guest.scheduledUnified.cart.preorderTitle": "Корзина предзаказа",
  "guest.scheduledUnified.cart.summary": "{count} позиций • {total}",
  "guest.scheduledUnified.cart.chooseProduct": "Выбрать блюдо",
  "guest.scheduledUnified.cart.course": "Порядок подачи {value}",
  "guest.scheduledUnified.cart.remove": "Удалить",
  "guest.scheduledUnified.cart.edit": "Изменить",
  "guest.scheduledUnified.cart.menuTitle": "Меню",
  "guest.scheduledUnified.cart.menuSubtitle": "Выберите позиции для предзаказа",
  "guest.scheduledUnified.cart.menuSearchPlaceholder": "Поиск блюд",
  "guest.scheduledUnified.cart.menuEmpty": "Ничего не найдено",
  "guest.scheduledUnified.cart.menuInCart": "В корзине: {count}",
  "guest.scheduledUnified.cart.addItem": "Добавить позицию",
  "guest.scheduledUnified.cart.itemFallback": "Позиция",
  "guest.scheduledUnified.cart.dialogDescription": "Настройте позицию перед добавлением в корзину.",
  "guest.scheduledUnified.cart.quantityLabel": "Количество",
  "guest.scheduledUnified.cart.courseLabel": "Порядок подачи",
  "guest.scheduledUnified.cart.commentLabel": "Комментарий",
  "guest.scheduledUnified.cart.commentPlaceholder": "Комментарий для кухни / официанта",
  "guest.scheduledUnified.cart.cancel": "Отмена",
  "guest.scheduledUnified.cart.updateItem": "Обновить позицию",
  "guest.scheduledUnified.cart.addToCart": "Добавить в корзину",
  "guest.scheduledUnified.review.title": "Проверка",
  "guest.scheduledUnified.review.cta.bookAndPay": "Забронировать и оплатить",
  "guest.scheduledUnified.review.date": "Дата: {value}",
  "guest.scheduledUnified.review.time": "Время: {value}",
  "guest.scheduledUnified.review.guests": "Гости: {value}",
  "guest.scheduledUnified.review.duration": "Длительность: {value} мин",
  "guest.scheduledUnified.review.guestNameLabel": "Имя",
  "guest.scheduledUnified.review.guestNamePlaceholder": "Ваше имя",
  "guest.scheduledUnified.review.guestEmailLabel": "Email",
  "guest.scheduledUnified.review.guestEmailPlaceholder": "you@example.com",
  "guest.scheduledUnified.review.guestPhoneLabel": "Телефон",
  "guest.scheduledUnified.review.guestPhonePlaceholder": "+371...",
  "guest.scheduledUnified.review.termsPrefix": "Я принимаю",
  "guest.scheduledUnified.review.termsLink": "условия использования",
  "guest.scheduledUnified.review.privacyLink": "политику конфиденциальности",
  "guest.scheduledUnified.review.publicOfferLink": "публичную оферту",
  "guest.scheduledUnified.review.andWord": "и",
  "guest.scheduledUnified.review.personalDataPrefix": "Я даю согласие на",
  "guest.scheduledUnified.review.personalDataLink": "обработку персональных данных",
  "guest.scheduledUnified.pay.title": "Оплата",
  "guest.scheduledUnified.pay.cta.start": "Перейти к оплате",
  "guest.scheduledUnified.pay.cta.processing": "Обработка…",
  "guest.scheduledUnified.waitlist.prompt": "Свободных столов нет. Добавить в лист ожидания?",
  "guest.scheduledUnified.waitlist.join": "В лист ожидания",
  "guest.scheduledUnified.waitlist.changeTime": "Сменить время",
  "guest.scheduledUnified.waitlist.created": "Заявка в лист ожидания создана.",
  "guest.scheduledUnified.featured.title": "Рекомендуем",
  "guest.scheduledUnified.featured.priceOnRequest": "Цена по запросу",
  "guest.scheduledUnified.result.successTitle": "Бронь и предзаказ подтверждены",
  "guest.scheduledUnified.result.successBody": "Подтверждение отправлено на email.",
  "guest.scheduledUnified.result.failureTitle": "Платеж не завершен",
  "guest.scheduledUnified.result.failureBody": "Бронь отменена. Попробуйте еще раз.",
  "guest.scheduledUnified.failure.code": "Код ошибки: {value}",
  "guest.scheduledUnified.failure.noChargeHint": "Если банк показал холд, он будет снят автоматически по правилам вашего банка.",
  "guest.scheduledUnified.failure.changeTime": "Выбрать другое время",
  "guest.scheduledUnified.failure.retry": "Повторить",
  "guest.scheduledUnified.steps.visit": "Визит",
  "guest.scheduledUnified.steps.cart": "Корзина",
  "guest.scheduledUnified.steps.review": "Проверка",
  "guest.scheduledUnified.errors.loadFailed": "Не удалось загрузить данные визита.",
  "guest.scheduledUnified.errors.tokenMissing": "Отсутствует токен magic-link.",
  "guest.scheduledUnified.errors.merchantMissing": "В URL виджета отсутствует merchant.",
  "guest.scheduledUnified.errors.createDraftFailed": "Не удалось создать черновик.",
  "guest.scheduledUnified.errors.invalidGuestName": "Укажите имя.",
  "guest.scheduledUnified.errors.invalidGuestEmail": "Укажите корректный email.",
  "guest.scheduledUnified.errors.invalidGuestPhone": "Укажите корректный номер телефона.",
  "guest.scheduledUnified.errors.selectTimeRequired": "Сначала выберите время визита.",
  "guest.scheduledUnified.errors.selectDishRequired": "Наполните корзину всем необходимым, чтобы мы успели подготовить заказ ко времени визита.",
  "guest.scheduledUnified.errors.termsNotAccepted": "Примите условия, политику конфиденциальности и оферту, чтобы продолжить.",
  "guest.scheduledUnified.errors.personalDataConsentRequired": "Требуется согласие на обработку персональных данных.",
  "guest.errors.productStopped": "Некоторые позиции больше недоступны. Обновите меню и удалите недоступные позиции из корзины.",
  "guest.unified.openOrders.title": "Открытые счета",
  "guest.unified.openOrders.subtitle": "Выберите оплату или добавьте позиции",
  "guest.unified.queue.title": "Корзина",
  "guest.unified.queue.subtitle": "Выбранные позиции и статус предзаказа",
  "guest.unified.queue.open": "Открыть очередь",
  "guest.unified.queue.close": "Закрыть очередь",
  "guest.unified.queue.addNewPurchase": "Добавить заказ",
  "guest.unified.queue.addToOrder": "Добавить в счет",
  "guest.unified.queue.placeOrder": "Отправить заказ",
  "guest.unified.queue.removeSelected": "Удалить выбранное",
  "guest.unified.queue.status.cart": "Корзина",
  "guest.unified.queue.status.notSent": "Не отправлено",
  "guest.unified.queue.status.inProgress": "В работе",
  "guest.unified.queue.status.accepted": "Принят",
  "guest.unified.queue.edit": "Изменить",
  "guest.unified.queue.cancel": "Отмена",
  "guest.unified.queue.movedToCart": "Перенесено в корзину",
  "guest.unified.queue.canceled": "Предзаказ отменен",
  "guest.unified.queue.actions": "Действия",
  "guest.stepper.select": "Выбор",
  "guest.stepper.amount": "Сумма",
  "guest.stepper.tip": "Чаевые",
  "guest.stepper.pay": "Оплата",
  "guest.stepper.done": "Готово",
  "guest.common.back": "Назад",
  "guest.common.or": "или",
  "guest.order.openedAt": "Открыт {time}",
  "guest.order.paid": "Оплачено",
  "guest.order.remaining": "Остаток",
  "guest.order.itemsLabel": "поз.",
  "guest.order.hideFullList": "Скрыть",
  "guest.order.moreItems": "+{count} еще",
  "guest.order.notPayable": "Не оплачивается",
  "guest.order.leaveTip": "Оставить чаевые",
  "guest.postVisitTip.notice": "Вы оставляете чаевые после визита для счета {orderLabel}.",
  "guest.postVisitTip.min": "Минимальная сумма чаевых картой — 1.00 {currency}.",
  "guest.postVisitTip.success.title": "Чаевые получены, спасибо!",
  "guest.postVisitTip.statusLabel": "Статус оплаты чаевых",
  "guest.postVisitTip.status.pending": "Ожидается",
  "guest.postVisitTip.status.processing": "Обработка",
  "guest.postVisitTip.status.requiresAction": "Требуется действие",
  "guest.postVisitTip.status.succeeded": "Успешно",
  "guest.postVisitTip.status.failed": "Ошибка",
  "guest.postVisitTip.status.canceled": "Отменено",
  "guest.footer.orderedTotal": "Заказано",
  "guest.footer.inCart": "В корзине",
  "guest.footer.cartTotal": "Сумма корзины",
  "guest.footer.selected": "Выбрано",
  "guest.footer.payingNow": "К оплате",
  "guest.footer.payer": "Плательщик",
  "guest.footer.remainingAfter": "Остаток после",
  "guest.checkout.reconcile.updatedSelection": "Состав обновлен. К оплате только актуальные заказы.",
  "guest.checkout.reconcile.continue": "Продолжить",
  "guest.footer.tip": "Чаевые",
  "guest.footer.total": "Итого",
};

export default guestRu;
